import { trans } from '@spotahome/soyuz/client';

import PaymentTimeline from '@spotahome/ui-library/src/tenant/components/PaymentTimeline';

import { ListingSectionObservable } from '../ListingSection';
import ListingTitle from '../ListingTitle';

import './ListingPaymentTimeline.scss';

const ListingPaymentTimeline = () => {
  return (
    <ListingSectionObservable section="pricing">
      <ListingTitle
        role="secondary"
        className="listing-payment-timeline__title"
      >
        {trans('listing.payment.timeline.title')}
      </ListingTitle>
      <p className="listing-payment-timeline__description">
        {trans('listing.payment.timeline.description')}
      </p>
      <PaymentTimeline />
    </ListingSectionObservable>
  );
};

export default ListingPaymentTimeline;
